export default `:host(ids-tab-content[active]) {
  display: block;
  color: var(--ids-tab-content-color-text);
  width: 100%;
}

:host(ids-tab-content:not([active])) {
  display: none;
}

:host([disabled]) {
  user-select: none;
  pointer-events: none;
}
:host([disabled]) .ids-tab-content-wrapper {
  opacity: var(--ids-opacity-disabled);
}

/* Lazy loading styles */
.ids-tab-content-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.ids-tab-content-loading {
  display: none;
  align-items: center;
  justify-content: center;
  padding: var(--ids-space-lg);
  min-height: 200px;
}

.ids-tab-content-error {
  display: none;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: var(--ids-space-none);
  min-height: 120px;
  text-align: center;
}

.ids-tab-content-main {
  width: 100%;
  height: 100%;
}

/* Loading state */
:host([loading]) .ids-tab-content-loading {
  display: flex;
}

:host([loading]) .ids-tab-content-main {
  display: none;
}

/* Error state */
:host([error]) .ids-tab-content-error {
  display: flex;
}

:host([error]) .ids-tab-content-main {
  display: none;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
